import { energyLabelState } from 'state/energyLabel';
import { userSession } from 'state/session';
import { showToast } from 'state/toast';
import { tenantConfig } from 'utils/tenant';
import { user } from 'utils/auth/user';
import { errorCollection } from 'config/ui/error-collection';
import { EErrorCode } from 'config/errors-codes';

export function handleResolverFallback(): void {
  const market = userSession().get('market');

  if (!market) {
    return;
  }

  if (!tenantConfig().isAllowed('energyLabel')) {
    return;
  }

  if (!user.isDealer) {
    return;
  }

  if (energyLabelState().get('fallbackActive')) {
    return;
  }

  energyLabelState().setFallbackActive(true);

  const entry = errorCollection[EErrorCode.ENERGY_LABEL_NOT_AVAILABLE];
  showToast({
    notificationId: entry.notificationId,
    type: 'warn',
    title: entry.title(),
    message: entry.message(),
  });
}
